var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00087 0.75C3.20876 0.75 0.945313 3.01345 0.945312 5.80556C0.945312 9.21806 5.40052 13.0729 5.5901 13.2372C5.82659 13.4395 6.17514 13.4395 6.41163 13.2372C6.63281 13.0729 11.0564 9.21806 11.0564 5.80556C11.0564 3.01345 8.79297 0.75 6.00087 0.75ZM6.00065 11.9056C4.65461 10.6417 2.20898 7.91799 2.20898 5.80729C2.20898 3.71321 3.90657 2.01562 6.00065 2.01562C8.09473 2.01562 9.79232 3.71321 9.79232 5.80729C9.79232 7.91799 7.34669 10.648 6.00065 11.9056ZM6.00043 3.28125C4.60438 3.28125 3.47266 4.41297 3.47266 5.80903C3.47266 7.20508 4.60438 8.33681 6.00043 8.33681C7.39649 8.33681 8.52821 7.20508 8.52821 5.80903C8.52821 4.41297 7.39649 3.28125 6.00043 3.28125V3.28125ZM6.00022 7.06684C5.30219 7.06684 4.73633 6.50098 4.73633 5.80295C4.73633 5.10492 5.30219 4.53906 6.00022 4.53906C6.69824 4.53906 7.26411 5.10492 7.26411 5.80295C7.26411 6.50098 6.69824 7.06684 6.00022 7.06684Z",
    fill: "#1B7EB3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelocation);
export default __webpack_public_path__ + "static/media/relocation.5444a251a25c9205160a2784fe78439a.svg";
export { ForwardRef as ReactComponent };